import React, { useEffect, useState  } from 'react';
import ContactModal from "../components/ContactModal";
import CustomerSay from "../components/CustomerSay";
import SeoHelmet from "../components/SeoHelmet";

import slide1 from "../assets/img/about_us_bg.jpg";
import Icon1 from "../assets/img/icon1.png";

import Sara1 from "../assets/img/rajkumar-jain.png";
import Sara2 from "../assets/img/sara_3.png";
import Sara3 from "../assets/img/sara_4.png";

import Work from "../assets/img/about_workdays_bg.svg";
import Work1 from "../assets/img/workdayz_img_1.jpg";
import Work2 from "../assets/img/w_logo.svg";
import Work3 from "../assets/img/w_logo_2.svg";

import Harmony5 from "../assets/img/harmony_logo.svg";
import Harmony from "../assets/img/harmony_group.png";

import aboutbg from "../assets/img/aboutbg.png";

import User1 from "../assets/img/user_1.jpg";
import User2 from "../assets/img/user_2.jpg";
import User3 from "../assets/img/user_3.jpg";

import People1 from "../assets/img/client_1.jpg";
import People2 from "../assets/img/client_2.png";
import People3 from "../assets/img/client_3.png";
import People4 from "../assets/img/client_4.jpg";
import Twitter from "../assets/img/twitter-logo.svg";
import Linkedin from "../assets/img/linkedin-logo.svg";
import fullcollimg from "../assets/img/aboutcoll.png";

import Map from "../assets/img/map_img.jpg";

const Aboutus = () => {

  const [activeVideo, setActiveVideo] = useState(null);

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };

  useEffect(() => {

    if (window.Swiper) {

 
      const custswiper = new window.Swiper(".customerslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        pagination: {
          el: ".swiper-paginationnn",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 3,

          },
          // You can add more breakpoints if needed
        },

      });

    }




  }, []);

  return (
    <>
      <SeoHelmet />
       <ContactModal />
      <section>
        <div className="swiper animeslide">
          <div className="swiper-wrapper">
            <div
              className="swiper-slide animeslide-slide slide1 about_us_slide"
              style={{ backgroundImage: `url(${slide1})` }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 banner_content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="about_cont"
        style={{ backgroundImage: `url(${aboutbg})` }}
      >
        <div className="container">
          <div className="content-slide about_sartrust">
            <div data-animate="bottom" className="animeslide-heading">
              <h2>About Us</h2>
              <p>
                We design and deliver premium uniforms tailored to your brand.
                From concept to completion, every garment is crafted with a deep
                understanding of your organization’s identity, functional
                requirements, and the impression you want to create. With a
                customization-first approach and end-to-end service—from design
                and prototyping to manufacturing and delivery—we bring together
                style, durability, and comfort, ensuring uniforms that work as
                hard as your team does
              </p>
            </div>
            <div data-animate="bottom" className="animeslide-desc">
              <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                <span>Let’s Get Started</span>
                <img src={Icon1} alt="" />
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="ambience_and_harmony_section ">
        <div className="container">
          <div className="row saraogi_legacy_content">
            <div className="col-sm-7">
              <div className="ambience_content">
                <div className="brands_content saraogi_legacy">
                  <h2>
                    Rooted in Craft, Built on Trust —<br></br> The Saraogi
                    Legacy
                  </h2>
                  <p>
                    We come from <b>The Saraogi Clothing Company,</b> a name
                    synonymous with<br></br> trust, quality, and innovation
                    since 1973. What began as a humble fabric<br></br> trading
                    enterprise in Chennai has grown into one of India’s most
                    respected<br></br> uniform and textile solution providers.
                    Over the past five decades, Saraogi<br></br> has partnered
                    with leading institutions, brands, and organizations—serving
                    <br></br> clients like Mercedes-Benz, MRF, and many
                    more—delivering uniforms that<br></br> embody precision,
                    durability, and style. This legacy of craftsmanship and
                    <br></br> customer-centricity continues to guide everything
                    we do today, ensuring<br></br> every uniform we create
                    carries the same promise of excellence.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-5">
              <div className="ambience_imgs">
                <div className="row">
                  <div className="col-sm-5 founder">
                    <img src={Sara1} alt="" className="sara1" />
                    <h3>Rajkumar Jain</h3>
                    <p>Founder</p>
                  </div>
                  <div className="col-sm-7">
                    <img src={Sara2} alt="" className="logom" />
                    <img src={Sara3} alt="" className="logom" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="brand_collaborated_section">
        <div className="container">
          <img src={fullcollimg} alt="" className="" />
        </div>
      </section>
      <section className="about_workdayz_section topleft">
        <div className="container">
          <div
            className="about_workdayz"
            style={{ backgroundImage: `url(${Work})` }}
          >
            <div className="row saraogi_legacy_content">
              <div className="col-sm-5">
                <div className="ambience_imgs workdayz_imgs">
                  <div className="row">
                    <img src={Work1} alt="" className="logom" />
                    <img src={Work2} alt="" className="work" />
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="ambience_content">
                  <div className="brands_content about_workdayz_content">
                    <h2>About Workdayz</h2>
                    <p>
                      <b>WorkDayz delivers custom-designed uniforms</b> for
                      diverse industries—from corporate offices and retail
                      stores to factories, hospitals, and government sectors.
                      Having <b>served 250+ brands across 60+ countries</b> and
                      developed <b>over 10 million uniforms,</b> we know what it
                      takes to combine functionality, durability, and style.
                      Through a collaborative design process and end-to-end
                      service, we create uniforms that truly reflect your brand
                      and withstand the demands of everyday work.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about_workdayz_section topright">
        <div className="container">
          <div
            className="about_workdayz about_ambience"
            style={{ backgroundImage: `url(${Work3})` }}
          >
            <div className="row saraogi_legacy_content">
              <div className="col-sm-6">
                <div className="ambience_content">
                  <div className="brands_content about_workdayz_content">
                    <h2>About Ambience and Harmony</h2>
                    <p>
                      <b>Ambience & Harmony specializes in redefining spaces</b>{" "}
                      through bespoke linens, robes, spa wear, and room
                      essentials tailored to your property’s character. From
                      luxury resorts to boutique stays, we help{" "}
                      <b>
                        reinvent interiors that align with your brand identity,
                      </b>{" "}
                      blending elegance, comfort, and lasting quality. Every
                      detail is thoughtfully designed to transform guest
                      experiences while bringing your brand’s essence to life.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-5">
                <div className="ambience_imgs workdayz_imgs">
                  <div className="row">
                    <img src={Harmony} alt="" className="logom" />
                    <img src={Harmony5} alt="" className="harmony" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="customer_say_section the_threads_section">
        <div className="container">
          <div className="brands_content customer_say_title teampartt">
            <h2>The People Behind the Threads</h2>
            <p>
              A passionate team turning ideas into finely crafted textiles,
              every single day.
            </p>
          </div>
          <div className="our_customer_say">
            <div className="row">
              <div className="col-sm-3"></div>
              <div className="col-sm-3">
                <div className="customer_say people">
                  <img src={People2} alt="" className="logom" />
                  <div className="people_title">
                    <div className="people_title_left">
                      <h3>Sunil Jain</h3>
                      <p>Director</p>
                    </div>
                    <div className="people_title_right">
                      {/* <img src={Twitter} alt="" className="logom" /> */}
                      <img src={Linkedin} alt="" className="logom" />
                    </div>
                  </div>
                 
                </div>
              </div>
              <div className="col-sm-3">
                <div className="customer_say people">
                  <img src={People3} alt="" className="logom" />
                  <div className="people_title">
                    <div className="people_title_left">
                      <h3>Anil Jain</h3>
                      <p>Director</p>
                    </div>
                    <div className="people_title_right">
                      {/* <img src={Twitter} alt="" className="logom" /> */}
                      <img src={Linkedin} alt="" className="logom" />
                    </div>
                  </div>
                 
                </div>
              </div>
              <div className="col-sm-3"></div>
            </div>
          </div>
        </div>
      </section>
      <section className="map_section">
        <div className="container">
          <div className="brands_content map_title">
            <h2>From Source to Seam: Supply Chain</h2>
          </div>
          <div className="map_img">
            <img src={Map} alt="" className="logom" />
          </div>
        </div>
      </section>
      <CustomerSay />
    </>
  );
};

export default Aboutus;
